<template>
  <div class="solar">


      <div class="icon-block" v-if="value==3">
        <div class="icon-block__inner">
          <SunnySvg class="icon weather" />
        </div>
        <div class="icon-block__waves">
          <SunnyWavesSvg />
        </div>
      </div>
      <div class="icon-block" v-else-if="value==2">
        <div class="icon-block__inner">
          <SunnyOverCloundsSvg class="icon weather" />
        </div>
        <div class="icon-block__waves">
          <SunOverCloudsWavesSvg />
        </div>
      </div>
      <div class="icon-block" v-else-if="value==1">
        <div class="icon-block__inner">
          <CloudySvg class="icon weather" />
        </div>
        <div class="icon-block__waves">
          <CloudyWavesSvg />
        </div>
      </div>
      <div class="icon-block" v-else>
        <div class="icon-block__inner">
          <NightSvg class="icon weather" />
        </div>
        <div class="icon-block__waves"></div>
      </div>
      <div class="solar__panel">
<!--      <div class="col-5 d-flex justify-content-end flex-column">-->
        <span class="desc">Instalacja fotowoltaiczna o mocy 5 kWp</span>
        <div class="solar__panel__image">
          <img class="img-fluid" src="@/assets/solar.png" />
        </div>
      </div>
    </div>
</template>

<script>

import SunnySvg from '@/assets/weather/sunny.svg';
import SunnyOverCloundsSvg from '@/assets/weather/sun-over-clouds.svg';
import CloudySvg from '@/assets/weather/cloudy.svg';
import NightSvg from '@/assets/weather/night.svg';

import SunnyWavesSvg from '@/assets/waves/sunny.svg';
import SunOverCloudsWavesSvg from '@/assets/waves/sun-over-clouds.svg';
import CloudyWavesSvg from '@/assets/waves/cloudy.svg';

export default {
  name: "Weather",
  components: {
    SunnySvg,
    SunnyOverCloundsSvg,
    CloudySvg,
    NightSvg,
    SunnyWavesSvg,
    SunOverCloudsWavesSvg,
    CloudyWavesSvg
  },
  props: {
    config: Object,
    value: Number,
  },
  methods: {

  }
}
</script>

<style lang="scss">

@keyframes waves {
  0%   { opacity: 0; transform: translateX(-50px); }
  50%   { opacity: 1; }
  100%   { opacity: 0; transform: translateX(+50px); }
}


#photovoltaics{
  .solar{
    grid-column: 1 / 3;
    grid-row: 2;
    column-gap: 1rem;
    row-gap: 2rem;

    display: grid;
    grid-template-columns: auto 50%;
    @include media-breakpoint-up(md) {
      grid-column: 1 / span 2;
      grid-template-columns: auto 130px;
    }
    @include media-breakpoint-up(lg) {
      grid-column: 1;
      grid-template-columns: auto 100px;
    }
    @include media-breakpoint-up(xl) {
      grid-row: 1 / 3;
      grid-template-columns: auto 200px;
    }

    &__panel{
      grid-column: 2;
      grid-row: 2;
      align-self: end;

      &__image{
        padding-left: 20px;
      }
      @include media-breakpoint-up(md) {
        grid-column: 2;
        grid-row: 1 / 3;
        &__image{
          padding-left: inherit;
        }
      }
    }
  }

  .icon-block{
    display: flex;
    flex-direction: row;
    align-content: center;
    align-self: end;
    @include media-breakpoint-up(md) {
      align-self: center;
    }
    grid-column: 1;
    grid-row: 2;
    svg{
      max-width: 100%;
    }
    &__inner{
      //width: 50%;

      display: flex;
      justify-content: flex-end;

      @include media-breakpoint-up(md) {
        flex-grow: 1;
      }

      svg{
        max-width: 57px;
      }
    }
    &__waves{
      width: 50%;
      display: flex;
      justify-content: center;

      animation-name: waves;
      animation-duration: 2s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;

      svg{
        max-width: 71px;
      }
    }
  }


}
</style>
